import { confirmPopup } from "primereact/confirmpopup";
import {
  PencilSimpleIcon,
  TrashSimpleIcon,
  WarningCircleIcon,
} from "@phosphor-icons/react";

import { ColaboraButton, TableBodyAction } from "..";

import "./TableActions.css";

type TableActionsPropsT = {
  rowData: { id: string };
  onEditClicked?: (id: string) => void;
  onDeleteConfirm?: (id: string) => void;
  showEdit?: boolean;
  showDelete?: boolean;
  editDisabled?: boolean;
  deleteDisabled?: boolean;
  editTooltip?: string;
  deleteTooltip?: string;
  deleteConfirmMessage?: string;
};

const buildDeleteConfirmMessage = (message: string) => (
  <div className="flex flex-col items-center gap-3 px-2 pt-2">
    <WarningCircleIcon size={48} weight="fill" className="text-orange-500" />
    <p className="text-sm text-center text-gray-700 m-0">{message}</p>
  </div>
);

const deleteConfirmFooter = (options) => (
  <div className="flex justify-end gap-2 p-2">
    <ColaboraButton
      className="!w-[8rem]"
      label="Cancelar"
      variant="secondary"
      onClick={options.reject}
    />
    <ColaboraButton
      className="!w-[8rem]"
      label="Eliminar"
      onClick={options.accept}
    />
  </div>
);

const TableActions = ({
  rowData,
  onEditClicked,
  onDeleteConfirm,
  showEdit = true,
  showDelete = true,
  editDisabled = false,
  deleteDisabled = false,
  editTooltip,
  deleteTooltip,
  deleteConfirmMessage,
}: TableActionsPropsT) => {
  const handleOnEditClicked = () => onEditClicked?.(rowData.id);

  const handleOnDeleteConfirm = () => onDeleteConfirm?.(rowData.id);

  const handleOnDeleteClicked = (e) => {
    confirmPopup({
      target: e.currentTarget,
      className: "before:!hidden after:!hidden",
      message: buildDeleteConfirmMessage(deleteConfirmMessage),
      footer: deleteConfirmFooter,
      accept: handleOnDeleteConfirm,
    });
  };

  if (!showEdit && !showDelete) {
    return null;
  }

  return (
    <fieldset
      aria-label="Acciones de la fila"
      className="flex justify-center content-center items-center gap-2 border-none p-0 m-0"
    >
      {showEdit && (
        <TableBodyAction
          icon={<PencilSimpleIcon size={30} />}
          toolTip={editTooltip}
          disabled={editDisabled}
          action={handleOnEditClicked}
        />
      )}
      {showDelete && (
        <TableBodyAction
          icon={<TrashSimpleIcon size={30} />}
          toolTip={deleteTooltip}
          disabled={deleteDisabled}
          action={handleOnDeleteClicked}
        />
      )}
    </fieldset>
  );
};

export default TableActions;
